import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { Badge, BadgeProps } from 'src/components/ui/badge';
import { cn } from 'src/lib/utils';
import { Mail } from 'lucide-react';

type Props = BadgeProps & {
  hasUnreadMessages: boolean;
  size?: 'default' | 'sm';
};

const RequestUnreadMessagesBadge: React.FC<Props> = ({
  hasUnreadMessages,
  size = 'default',
  className,
  ...props
}) => {
  const { t } = useTranslation();

  if (!hasUnreadMessages) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            className={cn(
              'tw-h-6 tw-w-6 tw-justify-center tw-rounded-full tw-border-0 tw-bg-orange tw-p-0 tw-font-medium hover:tw-bg-orange',
              className,
            )}
            {...props}
          >
            <Mail size={12} className="tw-text-white" />
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          {t('common:unread_messages', { defaultValue: 'Unread messages' })}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { RequestUnreadMessagesBadge };
